import { Store } from 'redux';
import { AppState } from './state/AppState';

export let storeInstance: Store<AppState> | null = null;

/** Sets the global instance of the app redux store. This should be called only once in the whole app. */
export function setAppStore(store: Store<AppState>): void {
  if (storeInstance) {
    throw new Error('Cannot overwrite app store; it has already been initialized');
  }
  storeInstance = store;
}

/**
 * Retrieves the global instance of the app redux store. This should only be used from outside
 * React components – within React components, use mapStateToProps/mapDispatchToProps.
 */
export function getAppStore() {
  if (!storeInstance) {
    throw new Error('Cannot access app store; it has not yet been initialized');
  }
  return storeInstance;
}
